module.exports = "https://cdn.hellotech.com/client-assets/wallmount_fixed_9d1d0d0631e233c226e4f230e7434e56.png";